document.addEventListener('DOMContentLoaded', () => {
  const defaultsBySection = new Map();

  const getRoot = () => document.querySelector('product-info.product-info-new');

  const getAllTargets = (root, selector) => Array.from(root?.querySelectorAll(selector) || []);

  const getTargets = (root) => ({
    description: getAllTargets(root, '[data-variant-content="description"]'),
    inTheBox: getAllTargets(root, '[data-variant-content="in-the-box"]'),
    knowMoreDescription: getAllTargets(root, '[data-accessories-know-more-body="description"]'),
    knowMoreBox: getAllTargets(root, '[data-accessories-know-more-body="box"]'),
    knowMoreCompatibility: getAllTargets(root, '[data-accessories-know-more-body="compatibility"]'),
    knowMoreSpec: getAllTargets(root, '[data-accessories-know-more-body="spec"]'),
    knowMoreNotes: getAllTargets(root, '[data-accessories-know-more-body="notes"]'),
  });

  const setPanelVisibility = (target, isVisible) => {
    const panel = target?.closest('[data-accessories-know-more-panel]');
    if (panel) panel.style.display = isVisible ? '' : 'none';
  };

  const variantContentKeys = [
    'descHtml',
    'inTheBoxHtml',
    'knowMoreBoxHtml',
    'knowMoreCompatibilityHtml',
    'knowMoreSpecHtml',
    'knowMoreNotesHtml',
  ];

  const hasVariantContent = (content) => {
    return Boolean(content && variantContentKeys.some((key) => content[key]));
  };

  const getDefaultHtml = (targetList) => targetList.map((target) => target.innerHTML);

  const updateHtmlTargets = (targetList, html, defaultHtmlList = [], useDefault = true) => {
    targetList.forEach((target, index) => {
      const nextHtml = html || (useDefault ? defaultHtmlList[index] || '' : '');
      if (target.innerHTML !== nextHtml) {
        target.innerHTML = nextHtml;
      }
    });
  };

  const updatePanelTargets = (targetList, html, defaultHtmlList = [], useDefault = true) => {
    targetList.forEach((target, index) => {
      let nextHtml = html || (useDefault ? defaultHtmlList[index] || '' : '');
      if (
        target.dataset.accessoriesKnowMoreBody === 'compatibility' &&
        target.closest('product-info')?.dataset.compatibilityEv1e === 'true' &&
        !nextHtml.includes('Strutt ev¹e')
      ) {
        nextHtml = nextHtml.replace(
          /(Strutt ev¹c,?)\s*<\/p>/,
          '$1<br>Strutt ev¹e</p>'
        );
      }
      if (target.innerHTML !== nextHtml) {
        target.innerHTML = nextHtml;
      }
      setPanelVisibility(target, Boolean(String(nextHtml || '').trim()));
    });
  };

  const captureDefaults = (root) => {
    const sectionId = root?.dataset?.section;
    if (!sectionId || defaultsBySection.has(sectionId)) return;

    const targets = getTargets(root);
    defaultsBySection.set(sectionId, {
      description: getDefaultHtml(targets.description),
      inTheBox: getDefaultHtml(targets.inTheBox),
      knowMoreDescription: getDefaultHtml(targets.knowMoreDescription),
      knowMoreBox: getDefaultHtml(targets.knowMoreBox),
      knowMoreCompatibility: getDefaultHtml(targets.knowMoreCompatibility),
      knowMoreSpec: getDefaultHtml(targets.knowMoreSpec),
      knowMoreNotes: getDefaultHtml(targets.knowMoreNotes),
    });
  };

  const getVariantContent = (sectionId, variantId) => {
    const jsonEl = document.getElementById(`VariantContentJSON-${sectionId}`);
    if (!jsonEl || !variantId) return null;

    try {
      const contentByVariant = JSON.parse(jsonEl.textContent || '{}');
      return contentByVariant[String(variantId)] || null;
    } catch (error) {
      return null;
    }
  };

  const renderVariantContent = (variantId) => {
    const root = getRoot();
    const sectionId = root?.dataset?.section;
    if (!root || !sectionId || !variantId) return;

    captureDefaults(root);

    const defaults = defaultsBySection.get(sectionId) || {};
    const content = getVariantContent(sectionId, variantId);
    const targets = getTargets(root);
    const useVariantContent = hasVariantContent(content);

    updateHtmlTargets(targets.description, null, defaults.description, true);
    updateHtmlTargets(targets.inTheBox, content?.inTheBoxHtml, defaults.inTheBox, !useVariantContent);
    updatePanelTargets(
      targets.knowMoreDescription,
      content?.knowMoreDescriptionHtml,
      defaults.knowMoreDescription,
      !useVariantContent
    );
    updatePanelTargets(targets.knowMoreBox, content?.knowMoreBoxHtml, defaults.knowMoreBox, !useVariantContent);
    updatePanelTargets(
      targets.knowMoreCompatibility,
      content?.knowMoreCompatibilityHtml,
      defaults.knowMoreCompatibility,
      !useVariantContent
    );
    updatePanelTargets(targets.knowMoreSpec, content?.knowMoreSpecHtml, defaults.knowMoreSpec, !useVariantContent);
    updatePanelTargets(targets.knowMoreNotes, content?.knowMoreNotesHtml, [], false);
  };

  window.renderVariantContent = renderVariantContent;

  const renderCurrentVariantContent = () => {
    const root = getRoot();
    const variantId = root?.dataset?.variantId || root?.querySelector('input[name="id"]')?.value;
    renderVariantContent(variantId);
  };

  renderCurrentVariantContent();

  if (window.subscribe && window.PUB_SUB_EVENTS) {
    const handleVariantContentUpdate = (event) => {
      const variantId = event?.data?.variant?.id;
      setTimeout(() => {
        renderVariantContent(variantId || getRoot()?.dataset?.variantId);
      }, 0);
    };

    window.subscribe(window.PUB_SUB_EVENTS.variantChange, handleVariantContentUpdate);
  }
});
